import * as t from "io-ts";
import * as util from "../../shared/src/util";

export const codec = t.type({
    type: t.literal("FILTER"),
    property: t.string,
    operator: t.union([
        t.literal("WORD_SEARCH_BEGINS_WITH_AND"),
        t.literal("WORD_SEARCH_BEGINS_WITH_OR"),
    ]),
    value: t.string,
});

export type T = t.TypeOf<typeof codec>;

export const operatorValues = util.typeValuesFromCodec(codec.props.operator.types as Array<t.LiteralC<T["operator"]>>);
